<template>
  <div class="bq-page" :class="{ 'bq-wireless-page': isMobile }">
    <banner
      class="bq-banner"
      type="horizontal"
      :cover="banner.cover"
      :mcover="banner.mcover"
    >
      <div class="bq-banner-content" slot="content">
        <h3 class="bq-banner-text">{{ banner.title }}</h3>
        <div class="bq-banner-line"></div>
      </div>
    </banner>

    <!--关于扁鹊-->
    <box class="bq-box-about bq-row" :title="about.title" id="about">
      <!--关于扁鹊-->
      <div class="bq-about-content">
        <div class="bq-about-left">
          <div class="bq-about-logo">
            <img :src="about.img" :alt="about.title" />
          </div>
        </div>
        <div class="bq-about-right">
          <div class="bq-about-text">
            <p v-for="(item, index) in about.content" :key="index">
              {{ item.text }}
            </p>
          </div>
        </div>
      </div>

      <!--认证-->
      <div class="bq-approve-content bq-row">
        <!-- <img
          :src="about.lineLeft.img"
          :alt="about.lineLeft.text"
          class="bq-approve-left"
        />
        <img
          :src="about.lineRight.img"
          :alt="about.lineRight.text"
          class="bq-approve-right"
        /> -->
        <div class="bq-approve-left" v-if="!isMobile"></div>
        <div class="bq-approve-right" v-if="!isMobile"></div>
        <ul class="bq-approve-list">
          <li
            class="bq-approve-item"
            v-for="(item, index) in about.approveData"
            :key="index"
          >
            <img :src="item.img" :alt="item.title" />
          </li>
        </ul>
      </div>
    </box>

    <!--扁鹊文化-->
    <box class="bq-box-culture bq-row" :title="culture.title" id="culture">
      <div class="bq-culture-content">
        <div class="bq-culture-left">
          <ul class="bq-culture-list">
            <div class="bq-culture-text">
              <li
                class="bq-culture-item"
                v-for="(item, index) in culture.belief"
                :key="index"
              >
                <span>{{ item.text }}</span>
              </li>
            </div>
          </ul>
        </div>
        <img :src="culture.img" :alt="culture.title" />
      </div>
    </box>

    <!--联系我们-->
    <box class="bq-box-contact bq-row" :title="contact.title" id="contact">
      <div class="bq-contact-content">
        <div class="bq-contact-left">
          <img :src="contact.imgUrl" :alt="contact.title" />
        </div>
        <div class="bq-contact-right">
          <ul class="bq-contact-list">
            <li
              class="bq-contact-item"
              v-for="(item, index) in contact.text"
              :key="index"
            >
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
import Box from '@/components/Box';
import Banner from '@/components/Banner';

import { banner, about, culture, contact } from './aboutBrush.js';
import { isWirelessDevice } from '../../../utils/utils';

Vue.use(Swipe).use(SwipeItem);

export default {
  name: 'about',

  components: {
    Banner,
    Box,
  },

  data() {
    return {
      isMobile: false,
      banner,
      about,
      culture,
      contact,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
